/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Visible_MembersInputs */

const en_admin_resource_form_visible_members = /** @type {(inputs: Admin_Resource_Form_Visible_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible to members`)
};

const de_admin_resource_form_visible_members = /** @type {(inputs: Admin_Resource_Form_Visible_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtbar für Mitglieder`)
};

const es_admin_resource_form_visible_members = /** @type {(inputs: Admin_Resource_Form_Visible_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible para miembros`)
};

const fr_admin_resource_form_visible_members = /** @type {(inputs: Admin_Resource_Form_Visible_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible pour les membres`)
};

const nl_admin_resource_form_visible_members = /** @type {(inputs: Admin_Resource_Form_Visible_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zichtbaar voor leden`)
};

/** @type {(inputs: Admin_Resource_Form_Visible_MembersInputs) => LocalizedString} */
const it_admin_resource_form_visible_members = en_admin_resource_form_visible_members;

/** @type {(inputs: Admin_Resource_Form_Visible_MembersInputs) => LocalizedString} */
const pt_br2_admin_resource_form_visible_members = en_admin_resource_form_visible_members;

/** @type {(inputs: Admin_Resource_Form_Visible_MembersInputs) => LocalizedString} */
const pl_admin_resource_form_visible_members = en_admin_resource_form_visible_members;

/** @type {(inputs: Admin_Resource_Form_Visible_MembersInputs) => LocalizedString} */
const hu_admin_resource_form_visible_members = en_admin_resource_form_visible_members;

/** @type {(inputs: Admin_Resource_Form_Visible_MembersInputs) => LocalizedString} */
const ro_admin_resource_form_visible_members = en_admin_resource_form_visible_members;

/**
* | output |
* | --- |
* | "Visible to members" |
*
* @param {Admin_Resource_Form_Visible_MembersInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_visible_members = /** @type {((inputs?: Admin_Resource_Form_Visible_MembersInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Visible_MembersInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_visible_members(inputs)
	if (locale === "de") return de_admin_resource_form_visible_members(inputs)
	if (locale === "es") return es_admin_resource_form_visible_members(inputs)
	if (locale === "fr") return fr_admin_resource_form_visible_members(inputs)
	if (locale === "nl") return nl_admin_resource_form_visible_members(inputs)
	if (locale === "it") return it_admin_resource_form_visible_members(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_visible_members(inputs)
	if (locale === "pl") return pl_admin_resource_form_visible_members(inputs)
	if (locale === "hu") return hu_admin_resource_form_visible_members(inputs)
	return ro_admin_resource_form_visible_members(inputs)
});
export { admin_resource_form_visible_members as "admin.resource_form.visible_members" }